import { render, staticRenderFns } from "./HeaderPromotion.vue?vue&type=template&id=00c34202&scoped=true"
import script from "./HeaderPromotion.vue?vue&type=script&lang=ts"
export * from "./HeaderPromotion.vue?vue&type=script&lang=ts"
import style0 from "./HeaderPromotion.vue?vue&type=style&index=0&id=00c34202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c34202",
  null
  
)

export default component.exports